module.exports = __webpack_public_path__ + "e-learning-app/static/img/cuowu.cc6c996.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/tiku/cuowu.png
// module id = S1/i
// module chunks = 1